<app-page-layout [displayCustomerService]="false" [isSubscription]="true">
    <div class="row">
        <div class="titre">
            <h3>{{('CATALOG.TITLE' ) | translate}}</h3>
            <mat-form-field *ngIf="DEVICE_TYPES.length>1" class="deviceFilter">
                <mat-label>{{'CATALOG.FILTER_TITLE' | translate}}</mat-label>
                <mat-select [formControl]="deviceFormControl" multiple>
                    <mat-select-trigger>
                        {{ getSelectTriggerDisplay() }}
                    </mat-select-trigger>
                    <div class="full-width top10">
                        <mat-checkbox class="select-checkbox" [checked]="selectAll" (change)="select()">
                            {{'CATALOG.FILTER_ALL' | translate}}
                        </mat-checkbox>
                    </div>
                    <mat-divider></mat-divider>
                    <mat-option *ngFor="let selectOption of DEVICE_TYPES" [value]="selectOption">
                        {{'DEVICE_TYPE.' + selectOption | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="main-frame">
            <div class="top30">
                <app-item-inventory [type]="B2B_BUSINESS" [deviceFilter]="deviceFormControl.value">
                </app-item-inventory>
            </div>
            <div class="center conditions">
                <a href="https://www.co-assist.fr/mentions-legales/" target="_blank"
                    rel="noopener noreferrer">{{'REGISTRATION.LEGAL_INFO'|translate}}</a>
            </div>
        </div>
    </div>
</app-page-layout>
